export const isEmailUrl = (url: string) => {
  return url.startsWith('mailto:');
};
